// extracted by mini-css-extract-plugin
export const txtTitle = "bannerFormContent-module--txtTitle--O9AxS";
export const txtSubTitle = "bannerFormContent-module--txtSubTitle--JvMg3";
export const loginAppIcon = "bannerFormContent-module--loginAppIcon--peg+4";
export const form = "bannerFormContent-module--form--Yzt6U";